module.exports = __webpack_public_path__ + "img/category-sport.8acd5b13.png";